import React, { Component } from 'react';
import { Layout } from 'antd';

const { Content } = Layout;
const headerHeight = 64;
class MainContent extends Component {


  constructor() {
    super();
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  componentDidMount() {
    this.props.onHeightRecorded(window.innerHeight - headerHeight);
    this.props.onWidthRecorded(window.innerWidth);
    // Additionally I could have just used an arrow function for the binding `this` to the component...
    window.addEventListener("resize", this.updateDimensions);
  }
  updateDimensions() {
    //console.log('IH:',window.innerHeight);
    this.props.onHeightRecorded(window.innerHeight - headerHeight);
    this.props.onWidthRecorded(window.innerWidth);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  render() {
    return (
      <Content>
        {this.props.children}
      </Content>
    );
  }
}

export default MainContent;

